import styled from 'styled-components';

import { flexEnd, flexStart } from '../../style/reusableStyle';

export const ProposalDetailsContainerStyled = styled.div`
  max-width: 930px;
  & .section-title {
    margin-bottom: 20px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    & .jobInformation {
      display: flex;
      flex-direction: row;
    }
  }
`;

export const ButtonEndContainerStyled = styled.div`
  width: 100%;
  ${flexEnd(16)};
`;

export const UploadedLogosContainerStyled = styled.div`
  ${flexStart};
  gap: 20px;
`;

export const ModalStyled = styled.div`
  backgound-color: aqua;
  height: 900px;
  width: 500px;
`;
